(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    const setHeaderHeight = () => {
      document.documentElement.style.setProperty('--site-header-height', `${header.offsetHeight}px`);
    };

    setHeaderHeight();
    window.addEventListener('load', setHeaderHeight, { once: true });
    window.addEventListener('resize', setHeaderHeight);

    if ('ResizeObserver' in window) {
      new ResizeObserver(setHeaderHeight).observe(header);
    }
  })();

  (() => {
    const overlay = document.querySelector('[data-page-transition]');
    if (!overlay) return;

    const arc = overlay.querySelector('[data-page-transition-arc]');
    const label = overlay.querySelector('[data-page-transition-progress]');
    let progress = 0;
    let progressTimer;
    let finishTimer;
    let finished = false;

    const renderProgress = value => {
      progress = Math.max(0, Math.min(100, Math.round(value)));
      if (arc) arc.style.strokeDashoffset = String(100 - progress);
      if (label) label.textContent = `${progress}%`;
    };

    const startProgress = () => {
      window.clearInterval(progressTimer);
      window.clearInterval(finishTimer);
      finished = false;
      renderProgress(0);
      progressTimer = window.setInterval(() => {
        if (progress >= 94) return;
        const step = Math.max(1, Math.ceil((94 - progress) * .09));
        renderProgress(Math.min(94, progress + step));
      }, 105);
    };

    const finishProgress = () => {
      if (finished) return;
      finished = true;
      window.clearInterval(progressTimer);
      finishTimer = window.setInterval(() => {
        renderProgress(progress + Math.max(2, Math.ceil((100 - progress) * .28)));
        if (progress >= 100) {
          window.clearInterval(finishTimer);
          window.setTimeout(() => overlay.classList.remove('is-visible'), 80);
        }
      }, 20);
    };

    if (window.Shopify && window.Shopify.designMode) {
      overlay.classList.remove('is-visible');
      return;
    }

    startProgress();

    if (document.readyState === 'complete') finishProgress();
    else window.addEventListener('load', finishProgress, { once: true });

    window.addEventListener('pageshow', event => {
      if (event.persisted) finishProgress();
    });
    window.setTimeout(finishProgress, 6000);

    document.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const link = event.target.closest('a[href]');
      if (!link || link.hasAttribute('download') || link.dataset.noTransition !== undefined) return;
      if (link.target && link.target !== '_self') return;

      const destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin) return;
      if (destination.protocol !== 'http:' && destination.protocol !== 'https:') return;
      if (destination.pathname === window.location.pathname && destination.search === window.location.search && destination.hash) return;

      event.preventDefault();
      startProgress();
      overlay.classList.add('is-visible');
      window.setTimeout(() => window.location.assign(destination.href), 280);
    });
  })();
  (() => {
    const targets = document.querySelectorAll(
      '.page-intro__grid, .values-section__head, .solution-heading, .partners__top, .partner-directory__head, .gallery-hero__content'
    );
    if (!targets.length) return;

    targets.forEach(target => target.classList.add('green-line-heading'));

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      targets.forEach(target => target.classList.add('green-line-visible'));
      return;
    }

    const lineObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('green-line-visible');
        lineObserver.unobserve(entry.target);
      });
    }, { threshold: .28 });

    targets.forEach(target => lineObserver.observe(target));
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-our-partners"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-testimonial-carousel]').forEach(carousel => {
    const slides = [...carousel.querySelectorAll('[data-testimonial-slide]')];
    if (slides.length < 2) return;
    const dots = [...carousel.querySelectorAll('[data-testimonial-dot]')];
    const current = carousel.querySelector('[data-testimonial-current]');
    const autoplay = carousel.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
    const delay = Number(carousel.dataset.delay) || 5000;
    let index = 0;
    let timer;

    const schedule = () => {
      clearTimeout(timer);
      if (autoplay) timer = setTimeout(() => show(index + 1), delay);
    };

    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      if (current) current.textContent = String(index + 1).padStart(2, '0');
      schedule();
    };

    carousel.querySelector('[data-testimonial-previous]')?.addEventListener('click', () => show(index - 1));
    carousel.querySelector('[data-testimonial-next]')?.addEventListener('click', () => show(index + 1));
    carousel.addEventListener('mouseenter', () => clearTimeout(timer));
    carousel.addEventListener('mouseleave', schedule);
    carousel.addEventListener('focusin', () => clearTimeout(timer));
    carousel.addEventListener('focusout', schedule);
    schedule();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-redesign"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach(section => {
    const variantSelect = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    const comparePrice = section.querySelector('[data-compare-price]');
    const addButton = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const quantityInput = section.querySelector('[data-quantity-input]');

    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.classList.toggle('is-hidden', !option.dataset.comparePrice);
      }
      if (addButton && addLabel) {
        addButton.disabled = !available;
        addLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;
      }
    });

    section.querySelectorAll('[data-quantity-change]').forEach(button => {
      button.addEventListener('click', () => {
        if (!quantityInput) return;
        const next = Math.max(1, Number(quantityInput.value || 1) + Number(button.dataset.quantityChange));
        quantityInput.value = String(next);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach(section => {
    const variantSelect = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    const comparePrice = section.querySelector('[data-compare-price]');
    const addButton = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const quantityInput = section.querySelector('[data-quantity-input]');
    const productForm = section.querySelector('.ft-product-form');
    const optionSelects = [...section.querySelectorAll('[data-product-option]')];
    const pairedConfigurator = section.querySelector('[data-paired-cable-configurator]');
    const cableGroups = [...section.querySelectorAll('[data-cable-group]')];
    const galleryRadios = [...section.querySelectorAll('.ft-product__gallery-radio')];
    const galleryThumbnails = [...section.querySelectorAll('.ft-product__thumbnail')];

    const showVariantMedia = variantOption => {
      const mediaIndex = Number(variantOption?.dataset.mediaIndex);
      if (!Number.isInteger(mediaIndex) || !galleryRadios[mediaIndex]) return;

      const radio = galleryRadios[mediaIndex];
      radio.checked = true;
      galleryThumbnails.forEach(thumbnail => {
        thumbnail.classList.toggle('is-active', thumbnail.getAttribute('for') === radio.id);
      });
    };

    const findVariantOption = optionSelectors => {
      if (!variantSelect) return null;

      return [...variantSelect.options].find(variantOption =>
        optionSelectors.every(optionSelect => {
          const position = optionSelect.dataset.optionPosition;
          return variantOption.dataset[`option${position}`] === optionSelect.value;
        })
      );
    };

    const updateStandardVariant = () => {
      const selectedVariant = findVariantOption(optionSelects);
      if (!selectedVariant) {
        if (addButton) addButton.disabled = true;
        return;
      }

      variantSelect.value = selectedVariant.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const selectedCableVariants = () => cableGroups.map(group => ({
      group,
      variant: findVariantOption([...group.querySelectorAll('[data-cable-option]')])
    }));

    const formatCurrency = cents => new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: pairedConfigurator?.dataset.currency || 'GBP'
    }).format(cents / 100);

    const updatePairedCablePrice = () => {
      if (!pairedConfigurator) return;
      const selections = selectedCableVariants();
      const valid = selections.every(selection => selection.variant);
      const available = valid && selections.every(selection => selection.variant.dataset.available === 'true');

      if (valid && price) {
        const totalCents = selections.reduce((total, selection) => total + Number(selection.variant.dataset.priceCents || 0), 0);
        price.textContent = formatCurrency(totalCents);
      }

      if (comparePrice) {
        comparePrice.textContent = '';
        comparePrice.classList.add('is-hidden');
      }

      if (addButton && addLabel) {
        addButton.disabled = !available;
        addLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;
      }
    };

    optionSelects.forEach(optionSelect => {
      optionSelect.addEventListener('change', updateStandardVariant);
    });

    cableGroups.forEach(group => {
      group.querySelectorAll('[data-cable-option]').forEach(optionSelect => {
        optionSelect.addEventListener('change', updatePairedCablePrice);
      });
    });

    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      const available = option.dataset.available === 'true';
      showVariantMedia(option);
      if (price) price.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.classList.toggle('is-hidden', !option.dataset.comparePrice);
      }
      if (addButton && addLabel) {
        addButton.disabled = !available;
        addLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantSelect.value);
      window.history.replaceState({}, '', url);
    });

    if (pairedConfigurator) {
      updatePairedCablePrice();

      productForm?.addEventListener('submit', async event => {
        event.preventDefault();
        const selections = selectedCableVariants();
        if (!selections.every(selection => selection.variant?.dataset.available === 'true')) return;

        const quantity = Math.max(1, Number(quantityInput?.value || 1));
        const items = selections.map(({ group, variant }) => {
          const chosenOptions = [...group.querySelectorAll('[data-cable-option]')];
          const properties = {
            'Cable colour': group.dataset.cableColour
          };

          chosenOptions.forEach(optionSelect => {
            const label = group.querySelector(`label[for="${optionSelect.id}"]`);
            properties[label?.textContent?.trim() || `Option ${optionSelect.dataset.optionPosition}`] = optionSelect.value;
          });

          properties._paired_configuration = '175A Anderson lead';
          return {
            id: Number(variant.value),
            quantity,
            properties
          };
        });

        if (addButton) addButton.disabled = true;

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });

          if (!response.ok) throw new Error('Unable to add this configuration to the basket.');
          window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
        } catch (error) {
          if (addButton) addButton.disabled = false;
          window.alert(error.message);
        }
      });
    }

    section.querySelectorAll('[data-quantity-change]').forEach(button => {
      button.addEventListener('click', () => {
        if (!quantityInput) return;
        const next = Math.max(1, Number(quantityInput.value || 1) + Number(button.dataset.quantityChange));
        quantityInput.value = String(next);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const counters = [...document.querySelectorAll('[data-stat-counter]')];
    if (!counters.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const prepareCounter = (element, index) => {
      const original = (element.dataset.counterValue || element.textContent || '').trim();
      const match = original.match(/^([^0-9-]*)(-?\d[\d,]*(?:\.\d+)?)(.*)$/);

      if (!match || reduceMotion) return null;

      const prefix = match[1];
      const numberText = match[2];
      const suffix = match[3];
      const target = Number(numberText.replace(/,/g, ''));
      if (!Number.isFinite(target)) return null;

      const decimals = (numberText.split('.')[1] || '').length;
      const useGrouping = numberText.includes(',');

      const format = value => value.toLocaleString('en-GB', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping
      });

      element.textContent = prefix + format(0) + suffix;

      return {
        element,
        target,
        prefix,
        suffix,
        format,
        delay: index * 110
      };
    };

    const prepared = counters.map(prepareCounter).filter(Boolean);
    if (!prepared.length) return;

    const animate = counter => {
      const duration = 1450;
      const startAt = performance.now() + counter.delay;

      const frame = now => {
        if (now < startAt) {
          requestAnimationFrame(frame);
          return;
        }

        const progress = Math.min(1, (now - startAt) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = counter.target * eased;
        counter.element.textContent = counter.prefix + counter.format(current) + counter.suffix;

        if (progress < 1) {
          requestAnimationFrame(frame);
        } else {
          counter.element.textContent = counter.element.dataset.counterValue;
        }
      };

      requestAnimationFrame(frame);
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const counter = prepared.find(item => item.element === entry.target);
        if (counter) animate(counter);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.45 });

    prepared.forEach(counter => observer.observe(counter.element));
  })();

  } catch(e) { console.error(e); }
})();
})();
